module.exports = __webpack_public_path__ + "img/badge-ar-fill.847c62e8.svg";